export type SplitMode = 'map' | 'zipcode' | 'stop' | 'algo';

/**
 * allowedModes 数字与 SplitMode 的映射：1=map, 2=zipcode, 3=stop, 4=algo
 */
export const SPLIT_MODE_NUM_MAP: Record<number, SplitMode> = { 1: 'map', 2: 'zipcode', 3: 'stop', 4: 'algo' };

/**
 * 将数字数组转换为可用的 SplitMode 列表，未配置时默认仅开启算法分单
 */
export function resolveAvailableModes(allowedModes: number[]): SplitMode[] {
    const modes = allowedModes.map(n => SPLIT_MODE_NUM_MAP[n]).filter(Boolean);
    return modes.length > 0 ? modes : ['algo'];
}

/**
 * 判断某个 splitMode 是否在可用列表中
 */
export function isModeAllowed(mode: string, availableModes: SplitMode[]): boolean {
    return availableModes.includes(mode as SplitMode);
}